import { gsap } from 'gsap';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'simple_toggle';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
		this.$trigger 		= 	this.options.$trigger?this.options.$trigger:this.$el;

		this.$toToggle 		=   this.$el;

		this.toggleClass    =   this.options.toggleClass?this.options.toggleClass:'is-open';


		if( this.$trigger.length <= 0 ){
			this.$trigger = this.$el;
		}


		if ( this.$el.attr( 'data-toggle' ) ){
			this.$toToggle = $( '.' + this.$el.attr( 'data-toggle' ) );
		}
		if ( this.$el.attr( 'data-class-toggle' ) ){
			this.toggleClass = this.$el.attr( 'data-class-toggle' );
		}



		this.init();
    }

    init(){



    	this.addEvents( true );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.$trigger.on( 'click', (e) => this.onChange(e) );
		}
		else{
			this.$trigger.off( 'click', (e) => this.onChange(e) );

		}
	}

	onChange(e){
		
		e.preventDefault();

		this.$toToggle.toggleClass( this.toggleClass );

		if ( this.$el.hasClass( 'hide-toggle' ) ){
			gsap.to( this.$el, {opacity:0, duration:0.3, onComplete:()=>{
				this.destroy();
				this.$el.remove();
			}})
		}
 	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	this.addEvents( false );
    }

}


